import { atomFamily } from "recoil";

export const PreviewImageFamily = atomFamily<
	string,
	{ stackCfKey: string; pageId: string }
>({
	key: "PreviewImageFamily",
	default: "",
});